module.exports = __webpack_public_path__ + "media/images/advertise-icon-1d6d71d3ad47b746d0dc2d763de84ab5.svg";